//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  components: {
  },
  data: function () {
    return {
      opened: false,
      typeComment: 'start',
      loading: false,
      labelHeader: '',
      selectedDefaultComment: null,
      defaultComments: [],
      comment: null
    }
  },
  watch: {
    typeComment: {
      handler: function (name) {
        switch (name) {
          case 'start':
            this.labelHeader = 'Комментарии при создании рейса'
            break
          case 'close':
            this.labelHeader = 'Комментарии при закрытии рейса'
            break
          case 'inside':
            this.labelHeader = 'Комментарии в процессе рейса'
            break
          case 'startVJ':
            this.labelHeader = 'Комментарии при выдаче ТС '
            break
          case 'closeVJ':
            this.labelHeader = 'Комментарии при сдаче ТС '
            break
          default:
            break
        }
      },
      immediate: true
    }
  },
  methods: {
    onAddComment: function () {
      this.opened = false
      this.$emit('set-comment', this.comment)
    }
  }
}

